import React from 'react';
import { Typography, Box, Stack } from '@mui/material';
import PropTypes from 'prop-types';

import { basename, dcConfig } from 'src/config';

const Logo = ({ appName, ...rest }) => {
  const logoFileName = `logo-${dcConfig.identifier}.svg`;

  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Box
        alt="logo"
        component="img"
        src={`${basename}/assets/${logoFileName}`}
        sx={{ mr: 1, height: 30 }}
      />
      <Typography {...rest}>{appName}</Typography>
    </Stack>
  );
};

Logo.propTypes = {
  appName: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.node.isRequired
  ])
};

export default Logo;
